import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { debounceMs: { type: Number, default: 300 } };
  timeout = null;

  submit() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.element.requestSubmit();
    }, this.debounceMsValue);
  }
}
